//src/modules/units/tyres/shared/tyre-csv.js
export function csvCell(value) {
  if (value === null || value === undefined) return '';

  const text = String(value);

  return /[",\r\n]/.test(text)
    ? `"${text.replace(/"/g, '""')}"`
    : text;
}

export function downloadCsv(filename, csv) {
  downloadBlob(filename, new Blob(
    ['\uFEFF' + csv],
    { type: 'text/csv;charset=utf-8;' }
  ));
}

/** Save any Blob (a CSV, an .xlsx …) under `filename` via a temporary link. */
export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = url;
  a.download = filename;

  document.body.appendChild(a);
  a.click();
  a.remove();

  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
